import getApiClient from '../../../../plugins/api'

export default {
    checkAccess: function() {

    },

    loadSurvey: function() {
        const self = this,
            api = getApiClient(self.$store),
            id = self.$route.params.id

        self.$store.commit('startLoading')

        api.get(`surveys/${id}/agency`)
        .then((result) => {
            self.survey = result.data
            self.surveyAnswers = {
                placeObservations: self.survey.placeObservations ?? '',
                agencyObservations: self.survey.agencyObservations,
                agencyAnswerDate: self.survey.agencyAnswerDate,
                observations: self.survey.observations ?? '',
                tripRank: self.survey.tripRank ?? 0,
                placeRank: self.survey.placeRank ?? 0,
                agencyRank: self.survey.agencyRank ?? 0,
                companyRank: self.survey.companyRank ?? 0
            }
        })
        .catch((error) => {
            console.log(error)
        })
        .finally(() => {
            self.$store.commit('stopLoading')
        })
    },

    sendReply: function(surveyId) {
        const api = getApiClient(this.$root.$store);
        this.$store.commit('startLoading')

        if (this.replyText) {
            api.patch(`/surveys/${surveyId}/agency`, {
                agencyObservations: this.replyText
            }, {
                headers: {
                    'Content-Type': 'application/merge-patch+json'
                }
            })
              .then(result => {
                  this.surveyAnswers.agencyObservations = result.data.agencyObservations
                  this.surveyAnswers.agencyAnswerDate = result.data.agencyAnswerDate
              })
              .catch(() => {})
              .finally(() => {
                  this.$store.commit('stopLoading')
              })
        }
    }
}
